module.exports = __webpack_public_path__ + "static/media/battles-tooltip-3.79ef9a51.png";